import { Component, input, signal } from '@angular/core';

@Component({
  selector: 'app-logo',
  standalone: true,
  imports: [],
  template: `
    @if (!imageError()) {
      <img [src]="size() === 'small' ? '/logo-sm.png' : (theme() === 'dark' ? '/logo.png' : '/logo-dark.png')" alt="Company Logo" [class]="size() === 'small' ? 'h-8 w-8 object-contain' : 'h-10 w-auto object-contain'" (error)="imageError.set(true)" />
    } @else {
      <div class="flex items-center gap-2">
        <div class="relative w-8 h-8 flex items-center justify-center">
          <i class="ti ti-droplet-filled text-amber-500 absolute -left-1 top-1 text-[20px]"></i>
          <i class="ti ti-droplet-filled text-[#4DB8E8] absolute text-[32px] z-10"></i>
          <i class="ti ti-droplet-filled text-[#2B9AD2] absolute left-1 top-0.5 text-[28px] z-0"></i>
        </div>
        @if (size() === 'full') {
          <div class="flex flex-col justify-center text-left">
            <div class="flex items-baseline gap-1">
              <span class="text-[16px] font-black leading-none tracking-tight" [class.text-white]="theme() === 'light'" [class.text-[#102C41]]="theme() === 'dark'">NZ PLUMBING</span>
            </div>
            <span class="text-[16px] font-black leading-none tracking-tight" [class.text-white]="theme() === 'light'" [class.text-[#102C41]]="theme() === 'dark'">LIMITED</span>
          </div>
        }
      </div>
    }
  `
})
export class LogoComponent {
  theme = input<'dark' | 'light'>('dark');
  size = input<'full' | 'small'>('full');
  imageError = signal(false);
}
